module.exports = {
      id: "rain-usage",
      viewBox: "0 0 38.4 27.718",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#rain",
      toString: function () {
        return this.url;
      }
    }